import React from "react";
import { IconsProps } from "./Icons";

export const InsightIcon = ({ className, width, height, viewBox }: IconsProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox={viewBox ? viewBox : "0 0 14 16"}
      width={width ? width : "14"}
      height={height ? height : "16"}
      fill="none"
    >
      <path
        d="M7 4.19986C7.3866 4.19986 7.7 3.88646 7.7 3.49986C7.7 3.11326 7.3866 2.79986 7 2.79986C6.6134 2.79986 6.3 3.11326 6.3 3.49986C6.3 3.88646 6.6134 4.19986 7 4.19986Z"
        fill="currentColor"
      />
      <path
        d="M2.8 11.1999H11.2V12.5999H2.8V11.1999ZM5.6 7.58086L7.5544 9.53666L10.3068 6.78216L11.2 7.69986V4.89986H8.4L9.317 5.79236L7.5537 7.55566L5.6 5.59986L2.8 8.39986L3.7898 9.38966L5.6 7.58086Z"
        fill="currentColor"
      />
      <path
        d="M11.9 1.39986H9.5914C9.52267 1.29636 9.44787 1.19702 9.3674 1.10236L9.3604 1.09396C8.84609 0.494937 8.12249 0.11486 7.3374 0.0313614C7.11447 -0.0110845 6.88553 -0.0110845 6.6626 0.0313614C5.87751 0.11486 5.15391 0.494937 4.6396 1.09396L4.6326 1.10236C4.55215 1.19679 4.47735 1.2959 4.4086 1.39916L2.1 1.39986C1.54322 1.40042 1.0094 1.62185 0.61569 2.01555C0.221984 2.40926 0.00055595 2.94308 0 3.49986V13.2999C0.00055595 13.8566 0.221984 14.3905 0.61569 14.7842C1.0094 15.1779 1.54322 15.3993 2.1 15.3999H11.9C12.4568 15.3993 12.9906 15.1779 13.3843 14.7842C13.778 14.3905 13.9994 13.8566 14 13.2999V3.49986C13.9994 2.94308 13.778 2.40926 13.3843 2.01555C12.9906 1.62185 12.4568 1.40042 11.9 1.39986ZM12.6 13.2999C12.6 13.4855 12.5262 13.6636 12.395 13.7948C12.2637 13.9261 12.0857 13.9999 11.9 13.9999H2.1C1.91441 13.9997 1.73647 13.9259 1.60523 13.7946C1.47399 13.6634 1.40019 13.4855 1.4 13.2999V3.49986C1.40019 3.31427 1.47399 3.13633 1.60523 3.00509C1.73647 2.87386 1.91441 2.80005 2.1 2.79986H5.285C5.36533 2.40426 5.57995 2.0486 5.89251 1.79313C6.20506 1.53766 6.59633 1.39811 7 1.39811C7.40367 1.39811 7.79494 1.53766 8.10749 1.79313C8.42004 2.0486 8.63467 2.40426 8.715 2.79986H11.9C12.0856 2.80005 12.2635 2.87386 12.3948 3.00509C12.526 3.13633 12.5998 3.31427 12.6 3.49986V13.2999Z"
        fill="currentColor"
      />
    </svg>
  );
};
